<template>
  <div>
    <vs-collapse class="bg-white mb-8 shadow rounded-none">
      <vs-collapse-item class="shadow-none">
        <div slot="header">Filter</div>
        <div class="vx-row mb-8">
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">Heute zuerst</label>
            <DataInput
              v-model="filter.todayFirst"
              type="bool"
              name="todayFirst"
            />
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">Berater</label>
            <DataInput
              v-model="filter.internalConsultant"
              type="model"
              placeholder="Berater"
              name="internalConsultant"
              allow-null
              model-label="
                firstName
                lastName"
              :select-label="el => el.firstName + ' ' + el.lastName"
              gql-query="consultantsPage"
              gql-single-query="consultant"
              gql-filter-type="objectFilter"
              @input="changeConsultant()"
            />
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">Benutzergruppe</label>
            <DataInput
              v-model="filter.userGroup"
              allow-null
              type="model"
              placeholder="Benutzergruppe"
              name="userGroupID"
              gql-query="userGroups"
            />
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">Art</label>
            <DataInput
              v-model="filter.type"
              allow-null
              type="model"
              name="type"
              placeholder="Art"
              model-label="nameResubmission"
              select-label="nameResubmission"
              gql-query="actionTypes"
            />
          </div>
        </div>
        <div class="vx-row mb-8">
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">Von</label>
            <DataInput
              v-model="filter.dateFrom"
              type="date"
              name="dateFrom"
              return-raw-date
              :config="{
                altFormat: 'd.m.Y',
                dateFormat: 'Y-m-d',
                enableTime: false,
                time_24hr: false
              }"
            />
          </div>
          <div class="vx-col md:w-1/5 sm:w-1/2 w-full">
            <label class="text-sm opacity-75">Bis</label>
            <DataInput
              v-model="filter.dateUntil"
              type="date"
              name="dateUntil"
              return-raw-date
              :config="{
                altFormat: 'd.m.Y',
                dateFormat: 'Y-m-d',
                enableTime: false,
                time_24hr: false
              }"
            />
          </div>
        </div>
        <div>
          <vs-button color="danger" class="float-right" @click="clearFilter"
            >Filter zurücksetzen</vs-button
          >
        </div>
      </vs-collapse-item>
    </vs-collapse>
    <div class="vx-card p-6">
      <div class="vx-row">
        <div v-if="myActionsPage" class="vx-col w-full">
          <vs-table :data="myActionsPage.results">
            <template slot="thead">
              <vs-th>Bewerber/Firma</vs-th>
              <vs-th>Datum</vs-th>
              <vs-th>Berater</vs-th>
              <vs-th>Art</vs-th>
              <vs-th>Erstellt am</vs-th>
              <vs-th>Aktion</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr v-for="(entry, i) in data" :key="entry.id" :data="entry">
                <vs-td>
                  <template v-if="entry.ref.__typename === 'Company'">
                    <router-link
                      :to="{
                        name: 'company.edit',
                        params: { id: entry.ref.id }
                      }"
                    >
                      {{ entry.ref.name }}
                    </router-link>
                  </template>
                  <template v-else-if="entry.ref.__typename === 'Applicant'">
                    <router-link
                      :to="{
                        name: 'applicant.edit',
                        params: { id: entry.ref.id }
                      }"
                    >
                      {{ entry.ref.firstName }} {{ entry.ref.lastName }}
                    </router-link>
                  </template>
                </vs-td>

                <vs-td>
                  {{
                    entry.remindAt ? $d(new Date(entry.remindAt), "long") : ""
                  }}
                </vs-td>

                <vs-td>
                  {{ entry.consultant ? entry.consultant.firstName : "" }}
                  {{ entry.consultant ? entry.consultant.lastName : "" }}
                </vs-td>

                <vs-td>
                  {{ entry.type ? entry.type.nameResubmission : "" }}
                </vs-td>

                <vs-td>
                  {{ $d(new Date(entry.createdAt), "long") }}
                </vs-td>

                <vs-td>
                  <feather-icon
                    icon="check"
                    svg-classes="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                    @click="doneEntry(i, entry)"
                  />
                  <feather-icon
                    icon="pen"
                    svg-classes="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                    @click="editEntry(i, entry)"
                  />
                  <feather-icon
                    icon="trash"
                    svg-classes="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                    @click="deleteRecord(i, entry)"
                  />
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>

          <vs-pagination
            v-model="currentPage"
            :total="totalPages"
            :max="7"
            class="mt-4"
            icon-pack="fas"
            prev-icon="fa-chevron-left"
            next-icon="fa-chevron-right"
          />
        </div>
        <div v-if="editing" id="action-form" class="vx-col w-full">
          <ActionForm
            v-model="form"
            type="RESUBMISSION"
            @submit="submitActionForm"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import ActionForm from "./Form";
import DataInput from "@/components/ui/DataInput";
import filterToQueryMixin from "@/mixins/filterToQueryMixin.js";

const query = gql`
  query MyActionsPage($page: Int, $filter: ActionFilter) {
    myActionsPage(page: $page, filter: $filter) {
      results {
        id
        title
        description
        done
        type {
          id
          nameResubmission
        }
        project {
          id
          number
          title
        }
        consultant {
          id
          firstName
          lastName
        }
        ref {
          ... on Applicant {
            id
            firstName
            lastName
          }
          ... on Company {
            id
            name
          }
        }
        dueAt
        remindAt
        createdAt
        remindAt
      }
      total
    }
  }
`;

export default {
  components: {
    ActionForm,
    DataInput
  },
  mixins: [
    filterToQueryMixin({
      internalConsultant: String,
      type: String,
      userGroup: String,
      todayFirst: Boolean,
      dateFrom: String,
      dateTo: String
    })
  ],
  data: () => ({
    editing: null,
    currentPage: 1,
    form: {},
    me: { consultant: {} },
    filter: {
      internalConsultant: null,
      type: null,
      userGroup: null,
      todayFirst: false,
      dateFrom: null,
      dateTo: null
    }
  }),
  apollo: {
    me: {
      query: gql`
        query Me {
          me {
            id
            consultant {
              id
            }
          }
        }
      `,
      update(data) {
        if (data.me.consultant) {
          this.filter.internalConsultant = data.me.consultant.id;
        }

        return data.me;
      }
    },
    myActionsPage: {
      query,
      fetchPolicy: "network-only",
      skip() {
        return !this.me.consultant || !this.me.consultant.id;
      },
      variables() {
        return {
          page: this.currentPage,
          filter: {
            done: false,
            consultantID: this.filter.internalConsultant,
            userGroupID: this.filter.userGroup,
            todayFirst: this.filter.todayFirst,
            typeID: this.filter.type,
            dateFrom: this.filter.dateFrom,
            dateUntil: this.filter.dateUntil
          }
        };
      }
    }
  },
  computed: {
    totalPages() {
      return this.myActionsPage
        ? Math.ceil(this.myActionsPage.total / 15)
        : null;
    }
  },
  methods: {
    async submitActionForm() {
      await this.$apollo.mutate({
        mutation: gql`
          mutation($id: ID!, $input: ActionInput!) {
            updateAction(id: $id, input: $input) {
              id
              description
              done
              title
              type {
                id
                nameResubmission
              }
              project {
                id
                title
              }
              consultant {
                id
                firstName
                lastName
              }
              ref {
                ... on Applicant {
                  id
                  firstName
                  lastName
                }
                ... on Company {
                  id
                  name
                }
              }
              dueAt
              remindAt
              createdAt
              remindAt
            }
          }
        `,
        variables: {
          id: this.editing,
          input: Object.prepareGqlInput(
            this.form,
            ["type", "consultant", "project"],
            ["createdAt", "ref"]
          )
        },
        update: () => {
          this.editing = null;
          this.form = null;
        }
      });

      this.$apollo.queries.myActionsPage.refetch();
    },
    editEntry(i, data) {
      this.editing = data.id;
      this.form = JSON.parse(JSON.stringify(data));
      setTimeout(() => {
        document.getElementById("action-form").scrollIntoView({
          behavior: "smooth"
        });
      }, 200);
    },
    doneEntry(i, data) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Erledigt bestätigen",
        text: `Du bist dabei, eine Wiedervorlage als erledigt zu markieren.`,
        accept: async () => {
          this.myActionsPage.results.splice(i, 1);

          await this.$apollo.mutate({
            mutation: gql`
              mutation($id: ID!) {
                markActionDone(id: $id) {
                  id
                }
              }
            `,
            variables: {
              id: data.id
            }
          });

          this.$apollo.queries.myActionsPage.refetch();
        },
        acceptText: "Fertig",
        cancelText: "Abbrechen"
      });
    },
    deleteRecord(i, data) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Löschen bestätigen",
        text: `Du bist dabei, eine Wiedervorlage zu löschen. Möchtest du diese wirklich löschen?`,
        accept: async () => {
          await this.$apollo.mutate({
            mutation: gql`
              mutation($id: ID!) {
                deleteAction(id: $id) {
                  id
                }
              }
            `,
            variables: {
              id: data.id
            }
          });

          this.$apollo.queries.myActionsPage.refetch();
        },
        acceptText: "Löschen",
        cancelText: "Abbrechen"
      });
    },
    changeConsultant() {
      if (this.filter.internalConsultant != null) {
        this.consultant = this.filter.internalConsultant;
      } else {
        this.consultant = this.me.consultant.id;
      }
    },
    clearFilter() {
      this.filter = {
        internalConsultant: null,
        type: null,
        userGroup: null,
        todayFirst: false,
        dateFrom: null,
        dateTo: null
      };
      this.filter.todayFirst = false;
      this.filter.dateFrom = null;
      this.filter.dateTo = null;
    }
  }
};
</script>
